import { Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import FormOne from "./FormOne";
import {
  ButtonFooter,
  ComponentHeader,
  PageHeader,
  Paper,
} from "../../../components";
import { colors } from "../../css components/Style";
import EditButtons from "../../../components/EditButtons";

export default function FormDisplay({
  agencyID,
  brandID,
  formikProps,
  editState,
  setEditState,
}) {
  const { state } = useLocation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageHeader
          pageName={"Company Details"}
          pageHeader={
            !formikProps.values.brandID
              ? "Let's add company details"
              : formikProps.values.companyName
          }
          buttons={[
            <EditButtons
              showBackButton={editState ? true : false}
              edit={true}
              editState={editState}
              setEditState={setEditState}
            />,
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <Paper gridSpacing={4}>
          <Grid item xs={12}>
            <ComponentHeader title={"Company Details"} />
          </Grid>
          {formikProps.values.is_brand_verified === 1 && (
            <Grid item xs={12}>
              <Typography variant="h6" color={colors.green}>
                This brand has been verified by admin.
              </Typography>
            </Grid>
          )}

          <FormOne
            agencyID={agencyID}
            brandID={brandID}
            formikProps={formikProps}
            editState={editState}
          />
        </Paper>

        {editState && (
          <Grid item xs={12}>
            <ButtonFooter
              editState={editState}
              route={state}
              setEditState={setEditState}
              ID={formikProps.values.ID}
              formikProps={formikProps}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
